// Smart Sash Admin Panel - Lab Service
// CRUD operations for lab management (v2 API)

import { axiosClient } from '../http/axiosClient';
import {
  LabDTO,
  CreateLabRequest,
  UpdateLabRequest,
  PaginatedResponse,
  PaginationParams,
  ApiPaginatedData,
  toPaginatedResponse,
} from '@/models';

const BASE_PATH = '/Lab';

/**
 * Lab Service (v2)
 */
export const labService = {
  /**
   * Get all labs with pagination
   */
  getAll: async (params?: PaginationParams): Promise<PaginatedResponse<LabDTO>> => {
    const response = await axiosClient.get<ApiPaginatedData<LabDTO>>(BASE_PATH, {
      params,
    });
    return toPaginatedResponse(response.data);
  },

  /**
   * Get lab by composite key (institutionId + labId)
   */
  getById: async (institutionId: string, labId: string): Promise<LabDTO> => {
    const response = await axiosClient.get<LabDTO>(`${BASE_PATH}/${institutionId}/${labId}`);
    return response.data;
  },

  /**
   * Create new lab
   */
  create: async (data: CreateLabRequest): Promise<LabDTO> => {
    const response = await axiosClient.post<LabDTO>(BASE_PATH, data);
    return response.data;
  },

  /**
   * Update existing lab by composite key
   */
  update: async (
    institutionId: string,
    labId: string,
    data: UpdateLabRequest
  ): Promise<LabDTO> => {
    const response = await axiosClient.put<LabDTO>(`${BASE_PATH}/${institutionId}/${labId}`, data);
    return response.data;
  },

  /**
   * Delete lab by composite key
   */
  delete: async (institutionId: string, labId: string): Promise<void> => {
    await axiosClient.delete(`${BASE_PATH}/${institutionId}/${labId}`);
  },
};

export default labService;
